(() => {
  if (!/^de(?:-|$)/i.test(document.documentElement.lang)) return;
  const labels = new Map(Object.entries({
    'PRODUCT REGISTRATION': 'PRODUKTREGISTRIERUNG',
    'First Name': 'Vorname', 'Last Name': 'Nachname', 'Email': 'E-Mail-Adresse',
    'Country': 'Land', 'Please select': 'Bitte auswählen', 'Product Name': 'Produktname',
    'Order ID /#': 'Bestellnummer', 'Amazon Review Link': 'Link zur Amazon-Bewertung',
    'Please upload your review proof of Amazon.': 'Bitte lade einen Nachweis deiner Amazon-Bewertung hoch.',
    'Choose file or drag here': 'Datei auswählen oder hierher ziehen',
    'Supported format: JPG, JPEG, PNG, GIF, SVG.': 'Unterstützte Formate: JPG, JPEG, PNG, GIF, SVG.',
    'Browse file': 'Datei auswählen', 'Submit': 'Absenden', 'Submitting...': 'Wird gesendet …',
    'Next': 'Weiter', 'Previous': 'Zurück', 'Back': 'Zurück', 'Remove': 'Entfernen',
    'Page 1': 'Seite 1', 'This field is required.': 'Dieses Feld ist erforderlich.',
    'This field is required': 'Dieses Feld ist erforderlich.',
    'Please enter a valid email address.': 'Bitte gib eine gültige E-Mail-Adresse ein.',
    'Please enter a valid email address': 'Bitte gib eine gültige E-Mail-Adresse ein.',
    'Please enter a valid URL.': 'Bitte gib eine gültige Internetadresse ein.',
    'File is too large': 'Die Datei ist zu groß',
    'Thank you for your submission!': 'Vielen Dank für deine Angaben!',
    'Your submission has been received.': 'Deine Angaben wurden übermittelt.'
  }));
  const countries = new Map();
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z]/g, '');
  if (typeof Intl.DisplayNames === 'function') {
    const en = new Intl.DisplayNames(['en'], { type: 'region' });
    const de = new Intl.DisplayNames(['de'], { type: 'region' });
    for (let a = 65; a <= 90; a++) for (let b = 65; b <= 90; b++) {
      const code = String.fromCharCode(a, b), name = en.of(code);
      if (name !== code) countries.set(normalize(name), de.of(code));
    }
    const aliases = {
      'Virgin Islands, British': 'VG', 'Republic of Cameroon': 'CM',
      'Congo, The Democratic Republic Of The': 'CD', 'Congo': 'CG',
      "Côte d'Ivoire": 'CI', 'Guinea Bissau': 'GW', 'Iran, Islamic Republic Of': 'IR',
      "Lao People's Democratic Republic": 'LA', 'Libyan Arab Jamahiriya': 'LY',
      'Macao': 'MO', 'Moldova, Republic of': 'MD', 'Korea, Democratic People\'s Republic Of': 'KP',
      'Palestinian Territory, Occupied': 'PS', 'Reunion': 'RE', 'St. Vincent': 'VC',
      'Tanzania, United Republic Of': 'TZ', 'Timor Leste': 'TL',
      'United States Minor Outlying Islands': 'UM', 'Holy See (Vatican City State)': 'VA',
      'Saint Martin': 'MF', 'Saint Helena': 'SH', 'Saint Barthélemy': 'BL',
      'Sao Tome And Principe': 'ST', 'Falkland Islands (Malvinas)': 'FK',
      'Heard Island And Mcdonald Islands': 'HM', 'Svalbard And Jan Mayen': 'SJ',
      'South Georgia And The South Sandwich Islands': 'GS', 'Netherlands Antilles': 'AN'
    };
    for (const [name, code] of Object.entries(aliases)) countries.set(normalize(name), de.of(code));
  }
  const translate = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      if (node.parentElement?.closest('script, style, textarea, [contenteditable="true"]')) continue;
      const value = node.nodeValue.trim(), replacement = labels.get(value);
      if (replacement) node.nodeValue = node.nodeValue.replace(value, replacement);
    }
    for (const element of root.querySelectorAll('[placeholder], [aria-label]')) {
      for (const attr of ['placeholder', 'aria-label']) {
        const replacement = labels.get(element.getAttribute(attr));
        if (replacement) element.setAttribute(attr, replacement);
      }
    }
    for (const option of root.querySelectorAll('select option[value]')) {
      const replacement = countries.get(normalize(option.value));
      if (replacement && option.textContent !== replacement) option.textContent = replacement;
    }
  };
  let scheduled = false;
  const scan = () => {
    scheduled = false;
    document.querySelectorAll('.globo-formbuilder').forEach(translate);
  };
  const schedule = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(scan); }
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  scan();
})();
